import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutComponent from '../components/About';

const About = () => {
    return (
        <>
            <Helmet>
                <title>About Us - Community Plus Care Services</title>
                <meta name="description" content="Learn more about Community Plus Care Services, our mission, and our dedication to providing high-quality NDIS support." />
            </Helmet>
            <AboutComponent />
        </>
    );
};

export default About;
